/* ==========================================================================
   Jackson Ultima - LEARN Fit Guide
   --------------------------------------------------------------------------
   Data transcribed from the official "Jackson Ultima Fit Guide" and
   "Learn to Skate Fit Guide" charts (Weight Fit Chart 2026, pages 1 & 2).
   The charts remain the source of truth; this tool is a lookup over them.

   Ported from the static prototype: the IIFE became a custom element so the
   theme editor re-initialises it on section reload, and model links resolve
   to Shopify pages instead of relative .html paths.
   ========================================================================== */

/* ----------------------------------------------------------------------
   Model catalogue - maps a chart entry to a series, a page and an image
   ---------------------------------------------------------------------- */
var CDN = 'https://cdn.shopify.com/s/files/1/0020/1251/2308/t/7/assets/';
var SHOP = 'https://jacksonskate.com/cdn/shop/products/';

var MODELS = {
  'Softec':          { series: 'Softec Series',   level: 'begin', href: 'features/softec.html',
                       img: SHOP + 'ST6100WH_-_No_Shadow_932deff5-5ddc-49a8-826a-0551b5f125f4.jpg?v=1622229049',
                       note: 'Recreational comfort, warmth and durability.' },
  '150/180 Series':  { series: 'Finesse Series',  level: 'begin', href: 'features/finesse.html',
                       img: SHOP + 'JS450_2000px1_f4f8b413-5157-4aa3-a566-4edfa4d0fbc4.jpg?v=1622229005',
                       note: 'Reinforced vinyl uppers with riveted Mark I blades.' },
  '500 Series':      { series: 'Classic Series',  level: 'begin', href: 'features/fusion-ascend.html#classic',
                       img: SHOP + 'JC500_Bottom_Enhanced.jpg?v=1754498098',
                       note: 'Traditional white recreational design, Mark II blade.' },
  'Excel':           { series: 'Ascend Series',   level: 'begin', href: 'features/fusion-ascend.html#ascend',
                       img: CDN + 'pf-979e4cca--Excel129001.png?v=1588881392',
                       note: 'Excel boot → Mark II blade.' },
  'Mystique':        { series: 'Ascend Series',   level: 'inter', href: 'features/fusion-ascend.html#ascend',
                       img: CDN + 'pf-9e4cca33--Mystique149001.png?v=1588881397',
                       note: 'Mystique boot → Mark II blade.' },
  'Artiste':         { series: 'Ascend Series',   level: 'inter', href: 'features/fusion-ascend.html#ascend',
                       img: CDN + 'pf-63c8979e--Artiste179001.png?v=1588881382',
                       note: 'Artiste boot → Mark IV blade.' },
  'Evo':             { series: 'Fusion Series',   level: 'inter', href: 'features/fusion-ascend.html#fusion',
                       img: CDN + 'pf-37da855d--FS2130AngleOut-Edited-Edited.jpg?v=1588879919',
                       note: 'EVO boot → Mark IV blade. Heat moldable.' },
  'Elle':            { series: 'Fusion Series',   level: 'inter', href: 'features/fusion-ascend.html#fusion',
                       img: CDN + 'pf-d3b93e0b--elle2130.png?v=1588880548',
                       note: 'Elle boot → Mirage blade. Heat moldable.' },
  'Freestyle':       { series: 'Fusion Series',   level: 'inter', href: 'features/fusion-ascend.html#fusion',
                       img: CDN + 'pf-da855dad--freestyle2190.png?v=1588880478',
                       note: 'Freestyle boot → Aspire XP blade. Heat moldable.' },

  /* Perfect Match boots - sold as a boot, paired with a blade of your choice */
  'Flex':            { series: '2000 Series',     level: 'inter', href: 'features/perfect-match.html#2000',
                       img: CDN + 'pf-978ddf54--FS20000101.jpg?v=1588106934', boot: true,
                       note: 'Fusion Series features with the flexibility of blade choice.' },
  'Entré':           { series: '2000 Series',     level: 'inter', href: 'features/perfect-match.html#2000',
                       img: CDN + 'pf-d0978ddf--Entre2330.jpg?v=1588106908', boot: true,
                       note: 'Moderate support of Elle or Freestyle, plus choice of blade.' },
  'Debut':           { series: '2000 Series',     level: 'elite', href: 'features/perfect-match.html#2000',
                       img: CDN + 'pf-0f805dee--Debut-Boots.jpg?v=1588184930', boot: true,
                       note: '5000 Series features in an intermediate-firm support.' },
  'Premiere':        { series: '2000 Series',     level: 'elite', href: 'features/perfect-match.html#2000',
                       img: CDN + 'pf-805dee02--Premiere-Boots.jpg?v=1588184944', boot: true,
                       note: 'Offset hooks and reinforced heel with aluminum plates.' },
  '5000 Series':     { series: '5000 Series',     level: 'elite', href: 'features/perfect-match.html#5000',
                       img: CDN + 'pf-ba9258d6--Elite-Boots.jpg?v=1588193873', boot: true,
                       note: 'Elite Pro, Elite and Supreme - tradition meets technology.' },
  /* Synergy Spark / Ignite / Torch appear on the 2026 fit chart but have no product page
     or photography on jacksonskate.com yet. Names and chart placement only - no spec copy
     is asserted here, and no stand-in photo is shown under the wrong product name. */
  'Synergy Spark':   { series: 'Synergy',         level: 'elite', href: 'features/perfect-match.html#5000',
                       img: null, boot: true,
                       note: 'Listed on the 2026 fit chart. No published specification yet - ask your dealer.' },
  'Synergy Ignite':  { series: 'Synergy',         level: 'elite', href: 'features/perfect-match.html#5000',
                       img: null, boot: true,
                       note: 'Listed on the 2026 fit chart. No published specification yet - ask your dealer.' },
  'Synergy Torch':   { series: 'Synergy',         level: 'elite', href: 'features/perfect-match.html#5000',
                       img: null, boot: true,
                       note: 'Listed on the 2026 fit chart. No published specification yet - ask your dealer.' },

  /* Blades */
  'Aspire XP':       { series: 'Ultima Blades',   level: 'inter', href: 'features/perfect-match.html#blades',
                       img: CDN + 'pf-50339af5--Legacy-Protege.jpg?v=1588966453', blade: true,
                       note: 'The introductory Ultima blade matched to the Freestyle boot.' },
  'Legacy':          { series: 'Ultima Blades',   level: 'inter', href: 'features/perfect-match.html#blades',
                       img: CDN + 'pf-50339af5--Legacy-Protege.jpg?v=1588966453', blade: true,
                       note: "Legacy range. Protege & Protege XP run an 8' rocker, intermediate competition profile." },
  'Matrix Legacy':   { series: 'Matrix Blades',   level: 'inter', href: 'features/perfect-match.html#blades',
                       img: CDN + 'pf-50339af5--Legacy-Protege.jpg?v=1588966453', blade: true,
                       note: "8' rocker, 420J stainless steel on an aluminum chassis." },
  'Apex Advanced':   { series: 'Apex Blades',     level: 'elite', href: 'features/perfect-match.html#blades',
                       img: CDN + 'pf-8b63c611--Advanced-Blades.jpg?v=1588967777', blade: true,
                       note: 'Titanium coating hardens the blade for superior edge life.' },
  'Matrix Advanced': { series: 'Matrix Blades',   level: 'elite', href: 'features/perfect-match.html#blades',
                       img: CDN + 'pf-8b63c611--Advanced-Blades.jpg?v=1588967777', blade: true,
                       note: '33% lighter on an aircraft-grade aluminum chassis.' },
  'Matrix RXS':      { series: 'Matrix Blades',   level: 'elite', href: 'features/perfect-match.html#blades',
                       img: CDN + 'pf-8b63c611--Advanced-Blades.jpg?v=1588967777', blade: true,
                       note: 'Listed on the 2026 fit chart with the Advanced blade range.' }
};

/* ----------------------------------------------------------------------
   Chart data
   Mass bands for Learn to Skate: 0 = <40lb/20kg, 1 = 40–80lb/20–40kg, 2 = >80lb/40kg
   ---------------------------------------------------------------------- */
var LTS = {
  can: {
    label: 'Skate Canada',
    levels: [
      { id: 'canskate12', label: 'CanSkate 1–2',   rows: [
        ['150/180 Series', '500 Series', 'Excel'], ['500 Series', 'Excel'], ['Excel', 'Mystique'] ] },
      { id: 'canskate35', label: 'CanSkate 3–5',   rows: [
        ['Excel'], ['Excel', 'Mystique'], ['Excel', 'Mystique', 'Artiste', 'Evo'] ] },
      { id: 'canskate56', label: 'CanSkate 5–6',   rows: [
        ['Excel', 'Mystique'], ['Mystique', 'Artiste', 'Evo'], ['Mystique', 'Artiste', 'Evo'] ] },
      { id: 'star12',     label: 'StarSkate 1–2',  rows: [
        ['Mystique', 'Artiste', 'Evo'], ['Mystique', 'Artiste', 'Evo', 'Elle'], ['Artiste', 'Evo', 'Elle'] ] },
      { id: 'star35',     label: 'StarSkate 3–5',  rows: [
        ['Artiste', 'Evo'], ['Artiste', 'Evo', 'Elle'], ['Evo', 'Elle', 'Freestyle'] ] },
      { id: 'star510',    label: 'StarSkate 5–10', rows: [
        ['Artiste', 'Evo', 'Elle'], ['Elle', 'Freestyle'], ['Elle', 'Freestyle'] ] }
    ]
  },
  usa: {
    label: 'US Figure Skating',
    levels: [
      { id: 'snowplow', label: 'Snowplow',  rows: [
        ['Softec', '500 Series', 'Excel'], ['Softec', '500 Series', 'Excel'], ['Excel', 'Mystique'] ] },
      { id: 'basic13',  label: 'Basic 1–3', rows: [
        ['500 Series', 'Excel'], ['Excel', 'Mystique'], ['Excel', 'Mystique', 'Artiste', 'Evo'] ] },
      { id: 'basic46',  label: 'Basic 4–6', rows: [
        ['Excel', 'Mystique'], ['Mystique', 'Artiste', 'Evo'], ['Mystique', 'Artiste', 'Evo', 'Elle'] ] },
      { id: 'prefree1', label: 'Pre-Free to Free Skate 1', rows: [
        ['Mystique', 'Artiste', 'Evo'], ['Mystique', 'Artiste', 'Evo', 'Elle'], ['Evo', 'Elle'] ] },
      { id: 'free24',   label: 'Free Skate 2–4', rows: [
        ['Artiste', 'Evo', 'Elle'], ['Elle', 'Freestyle'], ['Elle', 'Freestyle'] ] },
      { id: 'free56',   label: 'Free Skate 5–6', rows: [
        ['Artiste', 'Evo', 'Elle'], ['Elle', 'Freestyle'], ['Freestyle'] ] }
    ]
  }
};

var MASS_LTS = [
  { id: '0', label: 'Under 40 lb / 20 kg' },
  { id: '1', label: '40–80 lb / 20–40 kg' },
  { id: '2', label: 'Over 80 lb / 40 kg' }
];

/* Competitive chart - mass bands 0 = <60lb/30kg, 1 = 60–115lb/30–58kg, 2 = >115lb/58kg */
var MASS_COMP = [
  { id: '0', label: 'Under 60 lb / 30 kg' },
  { id: '1', label: '60–115 lb / 30–58 kg' },
  { id: '2', label: 'Over 115 lb / 58 kg' }
];

var COMP = {
  jumps: [
    { id: 'singles', label: 'Singles' },
    { id: 'doubles', label: 'Doubles' },
    { id: 'triples', label: 'Triples / Quads' }
  ],
  /* boots[jump][massBand] */
  boots: {
    singles: [
      ['Flex', 'Entré'],
      ['Flex', 'Entré', 'Debut'],
      ['Entré', 'Debut']
    ],
    doubles: [
      ['Flex', 'Entré'],
      ['Debut', 'Premiere', '5000 Series', 'Synergy Spark', 'Synergy Ignite'],
      ['Premiere', '5000 Series', 'Synergy Spark', 'Synergy Ignite']
    ],
    triples: [
      ['Debut', 'Synergy Spark'],
      ['Premiere', '5000 Series', 'Synergy Spark', 'Synergy Ignite'],
      ['5000 Series', 'Synergy Ignite', 'Synergy Torch']
    ]
  },
  /* blades apply to all skaters at that jump level */
  blades: {
    singles: ['Aspire XP', 'Legacy', 'Matrix Legacy'],
    doubles: ['Legacy', 'Matrix Legacy', 'Apex Advanced', 'Matrix Advanced', 'Matrix RXS'],
    triples: ['Apex Advanced', 'Matrix Advanced', 'Matrix RXS']
  },
  /* complete skates - singles only, split at 60 lb / 30 kg */
  complete: {
    singles: [ ['Elle', 'Freestyle'], ['Freestyle'], ['Freestyle'] ]
  }
};

/* --------------------------------------------------------------------------
   Element
   --------------------------------------------------------------------------
   <js-learn-fit-guide> owns the controls and the results list. The printed
   chart tables it highlights live in a sibling section, so those lookups are
   deliberately document-wide.
   -------------------------------------------------------------------------- */
class JsLearnFitGuide extends HTMLElement {
  connectedCallback() {
    this.els = {
      path: this.querySelector('[data-fit-path]'),
      levelF: this.querySelector('[data-field-level]'),
      level: this.querySelector('[data-fit-level]'),
      jumpF: this.querySelector('[data-field-jump]'),
      jump: this.querySelector('[data-fit-jump]'),
      mass: this.querySelector('[data-fit-mass]'),
      results: this.querySelector('[data-fit-results]'),
      summary: this.querySelector('[data-fit-summary]'),
      reset: this.querySelector('[data-fit-reset]')
    };

    if (!this.els.path || !this.els.results || !this.els.level || !this.els.jump || !this.els.mass) return;

    // Liquid supplies these: routes.root_url, and a map of prototype paths to
    // real page URLs. Both have fallbacks so the element works uninstrumented.
    this.rootUrl = this.dataset.rootUrl || '/';
    try {
      this.links = JSON.parse(this.dataset.links || '{}');
    } catch (e) {
      this.links = {};
    }

    this.state = { path: 'can', level: null, jump: 'singles', mass: '0' };

    this.bind();
    this.syncFields();
    this.fillLevels();
    this.fillJumps();
    this.fillMass();
    this.render();
  }

  /* ---------------------------------------------------------------- links */

  /* 'features/perfect-match.html#5000' -> '/pages/perfect-match#5000'.
     An explicit data-links entry wins; otherwise the filename becomes the handle. */
  modelHref(href) {
    const raw = String(href || '');
    const hashAt = raw.indexOf('#');
    const path = hashAt === -1 ? raw : raw.slice(0, hashAt);
    const hash = hashAt === -1 ? '' : raw.slice(hashAt);

    if (this.links[path]) return this.links[path] + hash;

    const handle = path.split('/').pop().replace(/\.html$/, '');
    return this.rootUrl.replace(/\/$/, '') + '/pages/' + handle + hash;
  }

  /* --------------------------------------------------------------- fields */

  static opt(value, label) {
    const o = document.createElement('option');
    o.value = value;
    o.textContent = label;
    return o;
  }

  fillLevels() {
    this.els.level.innerHTML = '';
    if (this.state.path === 'comp') return;
    LTS[this.state.path].levels.forEach((l) => {
      this.els.level.appendChild(JsLearnFitGuide.opt(l.id, l.label));
    });
    this.state.level = this.els.level.value;
  }

  fillJumps() {
    this.els.jump.innerHTML = '';
    COMP.jumps.forEach((j) => this.els.jump.appendChild(JsLearnFitGuide.opt(j.id, j.label)));
    this.els.jump.value = this.state.jump;
  }

  fillMass() {
    const bands = this.state.path === 'comp' ? MASS_COMP : MASS_LTS;
    this.els.mass.innerHTML = bands
      .map(
        (b) =>
          '<button type="button" data-mass="' +
          b.id +
          '" aria-pressed="' +
          (b.id === this.state.mass) +
          '">' +
          b.label +
          '</button>'
      )
      .join('');
  }

  syncFields() {
    const comp = this.state.path === 'comp';
    if (this.els.levelF) this.els.levelF.hidden = comp;
    if (this.els.jumpF) this.els.jumpF.hidden = !comp;
  }

  /* -------------------------------------------------------------- results */

  modelCard(name, kind) {
    const m = MODELS[name];
    if (!m) {
      return (
        '<article class="model"><div class="model__body">' +
        '<p class="model__name">' +
        name +
        '</p>' +
        '<p class="model__meta">See your dealer for details</p></div></article>'
      );
    }
    const tag = kind === 'blade' ? 'Blade' : kind === 'boot' ? 'Boot only' : 'Complete skate';
    const media = m.img
      ? '<div class="model__media"><img src="' + m.img + '" alt="' + name + '" loading="lazy"></div>'
      : '<div class="model__media model__media--none"><span>No photo published</span></div>';
    return (
      '<a class="model" href="' +
      this.modelHref(m.href) +
      '">' +
      media +
      '<div class="model__body">' +
      '<span class="badge badge--' +
      m.level +
      '" style="margin-bottom:.5rem">' +
      tag +
      '</span>' +
      '<p class="model__name">' +
      name +
      '</p>' +
      '<p class="model__meta">' +
      m.series +
      ': ' +
      m.note +
      '</p>' +
      '</div>' +
      '</a>'
    );
  }

  group(title, hint, names, kind) {
    if (!names || !names.length) return '';
    return (
      '<div class="fit-group">' +
      '<div class="fit-group__head">' +
      '<h3>' +
      title +
      '</h3>' +
      (hint ? '<p class="small muted">' + hint + '</p>' : '') +
      '</div>' +
      '<div class="grid grid--4">' +
      names.map((n) => this.modelCard(n, kind)).join('') +
      '</div>' +
      '</div>'
    );
  }

  render() {
    const mass = parseInt(this.state.mass, 10);
    let html = '';
    let summary = '';

    if (this.state.path === 'comp') {
      const jump = COMP.jumps.filter((j) => j.id === this.state.jump)[0];
      summary =
        'Competitive skater landing <strong>' +
        jump.label.toLowerCase() +
        '</strong>, <strong>' +
        MASS_COMP[mass].label.toLowerCase() +
        '</strong>.';

      html += this.group(
        'Boots',
        'Paired with a blade of your choice - this is the Perfect Match program.',
        COMP.boots[this.state.jump][mass],
        'boot'
      );
      html += this.group(
        'Blades',
        'The chart lists these for all skaters at this jump level.',
        COMP.blades[this.state.jump],
        'blade'
      );
      if (this.state.jump === 'singles') {
        html += this.group(
          'Complete skates',
          'If you would rather buy a matched outfit than specify a boot and blade.',
          COMP.complete.singles[mass],
          'complete'
        );
      }
    } else {
      const chart = LTS[this.state.path];
      let lvl = chart.levels.filter((l) => l.id === this.state.level)[0];
      if (!lvl) {
        lvl = chart.levels[0];
        this.state.level = lvl.id;
      }
      summary =
        '<strong>' +
        chart.label +
        ' ' +
        lvl.label +
        '</strong>, ' +
        '<strong>' +
        MASS_LTS[mass].label.toLowerCase() +
        '</strong>.';
      html += this.group('Recommended skates', '', lvl.rows[mass], 'complete');
    }

    if (this.els.summary) this.els.summary.innerHTML = summary;
    this.els.results.innerHTML = html || '<p class="fit-empty">No recommendation for that combination.</p>';
    this.highlightTables();
  }

  /* Highlight the matching row in the printed chart tables, which sit in the
     charts section further down the page - hence document, not this. */
  highlightTables() {
    document.querySelectorAll('.fit-table tbody tr').forEach((tr) => tr.classList.remove('is-hit'));
    const sel =
      this.state.path === 'comp'
        ? '#chart-comp tbody tr[data-mass="' + this.state.mass + '"]'
        : '#chart-' + this.state.path + ' tbody tr[data-level="' + this.state.level + '"]';
    document.querySelectorAll(sel).forEach((tr) => tr.classList.add('is-hit'));
  }

  /* --------------------------------------------------------------- events */

  bind() {
    this.els.path.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-path]');
      if (!btn) return;
      this.els.path.querySelectorAll('[data-path]').forEach((b) => {
        b.setAttribute('aria-pressed', String(b === btn));
      });
      this.state.path = btn.getAttribute('data-path');
      this.state.mass = '0';
      this.syncFields();
      this.fillLevels();
      this.fillMass();
      this.render();
    });

    this.els.mass.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-mass]');
      if (!btn) return;
      this.els.mass.querySelectorAll('[data-mass]').forEach((b) => {
        b.setAttribute('aria-pressed', String(b === btn));
      });
      this.state.mass = btn.getAttribute('data-mass');
      this.render();
    });

    this.els.level.addEventListener('change', () => {
      this.state.level = this.els.level.value;
      this.render();
    });

    this.els.jump.addEventListener('change', () => {
      this.state.jump = this.els.jump.value;
      this.render();
    });

    if (this.els.reset) {
      this.els.reset.addEventListener('click', () => {
        this.state = { path: 'can', level: null, jump: 'singles', mass: '0' };
        this.els.path.querySelectorAll('[data-path]').forEach((b) => {
          b.setAttribute('aria-pressed', String(b.getAttribute('data-path') === 'can'));
        });
        this.syncFields();
        this.fillLevels();
        this.fillJumps();
        this.fillMass();
        this.render();
      });
    }
  }
}

if (!customElements.get('js-learn-fit-guide')) {
  customElements.define('js-learn-fit-guide', JsLearnFitGuide);
}
